import { Validators } from '@angular/forms';
import { FormControlOptions } from '@miq/catalog';

/**
 * This file depicts the shape of a "Availability" form. it includes and configures inputs in controlConfigs
 * attribute that are not part of the catalog but that are essential for a form to have as hidden field
 * or values, usually id controls or hidden/missing columns
 *
 * Since we rely entirely on catalog to "generate" form and control options on each level, few attributes
 * are not provided in the catalog but needs to be present as explained above. Therefore this file works
 * as a skeleton form control options for those essential attributes that are not part of the catalog
 */
export const TimFormConfig: { [key: string]: FormControlOptions<any> } = {
  // Tim  Notes
  tim_notes: {
    type: 'array',
    name: 'tim_notes',
    controlsConfig: {
      id: [''],
      notes: [''],
      record_source_comment: [''],
      party_space_requirement_notes_type_desc: [''],
    },
  },
  usages: {
    type: 'array',
    name: 'usages',
    controlsConfig: {
      id: [null],
      _mode: [null],
    },
  },
  tim_option: {
    type: 'array',
    name: 'tim_option',
    controlsConfig: {
      id: [''],
      option_start_date: [null, [Validators.required]],
      option_type_desc: [null],
    },
  },
  company_industry_classification: {
    name: 'company_industry_classification',
    type: 'array',
    controlsConfig: {
      id: [null],
      ref_naics_classification_desc: [null],
      primary_naics_code_f: [null],
      primary_industry_code_f: [null],
      ref_cbre_industry_code_desc: [null],
      _mode: [null],
    },
  },
  target_geography: {
    name: 'target_geography',
    type: 'group',
    children: {
      lig_geography: {
        type: 'array',
        name: 'lig_geography',
        controlsConfig: {
          id: [null],
          global_region_desc: [null],
        },
      },
      city: {
        type: 'array',
        name: 'city',
        controlsConfig: { id: [null], _mode: [null] },
      },
    },
  },
  current_geography: {
    name: 'current_geography',
    type: 'group',
    children: {
      lig_geography: {
        type: 'array',
        name: 'lig_geography',
        controlsConfig: {
          id: [''],
          global_region_desc: [null],
        },
      },
    },
  },
  company_contact_role_addresses: {
    name: 'company_contact_role_addresses',
    type: 'array',
    controlsConfig: {
      id: [''],
      _mode: [null],
      _contact_id: [null], // ensure presence
      display_order: [null], // ensure presence
      prev_display_order: [null], // ensure presence
      company_id: [null], // ensure presence
      contact_id: [null], // ensure presence
      location_id: [null], // ensure presence - flat mirror of location.location_id (MIQ-36890)
      children: [],
      location: [],
    },
    children: {
      company_industry_classification: {
        name: 'company_industry_classification',
        type: 'array',
        controlsConfig: {
          id: [null],
          ref_naics_classification_desc: [null],
          primary_naics_code_f: [null],
        },
      },
    },
  },
  property_association: {
    name: 'property_association',
    type: 'array',
    controlsConfig: {
      id: [''],
      children: {
        property_usage: {
          name: 'property_usage',
          type: 'array',
          controlsConfig: {
            id: [null],
          },
        },
      },
      total_gross_area_uom: [null],
      postal_address: {
        name: 'postal_address',
        type: 'group',
        children: {
          colloquial: {
            name: 'colloquial',
            type: 'array',
            controlsConfig: {
              country_code_desc: [],
              language_desc: [],
              id: [null],
              full_street_name: [null],
            },
          },
        },
      },
    },
  },
};
